import { AuthSession } from './authSession';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL ?? 'http://localhost:5000/api';

interface ApiErrorShape {
  message?: string;
}

const apiClient = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json'
  }
});

const getErrorMessage = (error: unknown): string => {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data as ApiErrorShape | undefined;
    return data?.message ?? error.message;
  }

  return 'Request failed';
};

export interface LoginPayload {
  email: string;
  password: string;
}

export const login = async (payload: LoginPayload): Promise<AuthSession> => {
  try {
    const { data } = await apiClient.post<{
      token: string;
      user: AuthSession['user'];
    }>('/auth/login', payload);

    return { token: data.token, user: data.user };
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const register = async (payload: FormData): Promise<void> => {
  try {
    await apiClient.post('/auth/register', payload, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};
